import axios from 'axios'
import { jsonConfig } from '../Certs'
import Cookies from 'js-cookie'

const functions = {
    formatCpf: (cpf) => {
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")

    }
}

const conection = {
    index: () => {
        const instance = axios.create(
            {
                baseURL: jsonConfig.urlAPI,
                withCredentials: true,
                headers: {
                    "proxyauthorization": jsonConfig.APIKEY

                }
            }
        )
        instance.interceptors.request.use(async (config) => {
            const method = config.method?.toUpperCase();
            if (['POST', 'PUT', 'DELETE'].includes(method)) {
                // busca o token csrf antes da requisição
                const { data } = await axios.get(`${jsonConfig.urlAPI}/csrftoken`, {
                    withCredentials: true,
                    headers: {
                        "proxyauthorization": jsonConfig.APIKEY,

                    }
                });
                config.headers['X-CSRF-Token'] = data.csrfToken;
            }
            return config;
        }, error => {
            console.log(error)
            return Promise.reject(error);
        });

        return instance;
    }
}

const truncate = (str, n) => {
    return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
};

const formatCpf = (cpf) => {
    return cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")

}


export { functions, conection, truncate, formatCpf }